import { Check, X } from 'lucide-react';
import type { UseFormReturn, FieldPath, FieldValues } from 'react-hook-form';

interface AccordionTriggerLabelProps<T extends FieldValues> {
  fieldNames: FieldPath<T>[];
  label: string;
  form: UseFormReturn<T>;
  isFormValid?: boolean;
}

export const AccordionTriggerLabel = <T extends FieldValues>({
  fieldNames,
  label,
  form
}: AccordionTriggerLabelProps<T>) => {
  const isValid = fieldNames.every((fieldName) => {
    const fieldState = form.getFieldState(fieldName);
    return (
      (fieldState.isDirty && !fieldState.invalid) || (fieldState.isTouched && !fieldState.invalid)
    );
  });

  const isInvalid = fieldNames.some((fieldName) => {
    const fieldState = form.getFieldState(fieldName);
    return fieldState.invalid;
  });

  if (isInvalid) {
    return (
      <span className="flex items-center">
        <span className="flex items-center justify-center w-6 h-6 mr-2 rounded-full bg-destructive">
          <X size={12} className="!m-0" color="white" />
        </span>
        {label}
      </span>
    );
  }
  if (isValid) {
    return (
      <span className="flex items-center">
        <span className="flex items-center justify-center w-6 h-6 mr-2 rounded-full bg-success">
          <Check size={12} className="!m-0" color="white" />
        </span>
        {label}
      </span>
    );
  }
  return label;
};
